import React, { FC } from "react";
import { FormControl, FormErrorMessage, RadioGroup, Stack } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { FormatPrice } from "src/utils/formatPrice";
import { SmilePlusPlansPayload } from "types/Queries/Plan";
import { SmilePlusSubscriptionPlanProductEnum } from "types/User";
import SmileSharedPlanRadio from "./SmileSharedPlanRadio";

export interface SmileSharedPlanRadioGroupProps {
  plans: SmilePlusPlansPayload;
  defaultPlan: SmilePlusSubscriptionPlanProductEnum;
  formatPrice: FormatPrice;
}

const SmileSharedPlanRadioGroup: FC<SmileSharedPlanRadioGroupProps> = (props) => {
  const { errors } = useFormContext();
  return (
    <FormControl id="plan" as="fieldset" isInvalid={!!errors.plan}>
      <RadioGroup defaultValue={props.defaultPlan}>
        <Stack spacing="10px">
          {props.plans.smilePlusPlans.plans.map((plan) => (
            <SmileSharedPlanRadio plan={plan} formatPrice={props.formatPrice} key={plan.plan} />
          ))}
        </Stack>
      </RadioGroup>
      <FormErrorMessage>{!!errors.plan && errors.plan.message}</FormErrorMessage>
    </FormControl>
  );
};

export default SmileSharedPlanRadioGroup;
